import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { FormInput } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import moment from 'moment'
import SemanticDatepicker from 'react-semantic-ui-datepickers'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'

@observer
class DatePicker extends Component {
  static propTypes = {
    formEntry: PropTypes.instanceOf(FormEntry),
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    isFixed: PropTypes.bool,
    ...FormInput.propTypes
  }

  static defaultProps = {
    isFixed: false
  }

    handleOnChangeInput = (event, data) => {
      const { formEntry, isFixed } = this.props
      formEntry.updateValue(data.name, data.value, isFixed)
    }

    render () {
      const {
        formEntry,
        defaultValue,
        name,
        options,
        onChange,
        castValue,
        parseValue,
        errorPointing,
        error,
        isFixed,
        ...props
      } = this.props
      let value = formEntry.getValue(name, isFixed)
      if (typeof value === 'string') {
        if (value) {
          value = moment(value, 'YYYY-MM-DD').toDate()
        } else {
          value = null
        }
      }
      return (
        <FormInput
          as={SemanticDatepicker}
          format='DD-MM-YYYY'
          value={parseValue ? parseValue(value) : value}
          name={name}
          onChange={onChange || this.handleOnChangeInput}
          transparent={formEntry.readonly}
          readOnly={formEntry.readonly}
          {...props}
        />
      )
    }
}

export default DatePicker
